// @ts-nocheck
import * as Yup from 'yup';

const createImgValidation = () => {
  return Yup.mixed()
    .notRequired()
    .test('fileSize', 'File size must be less than 1 MB', value => !value || value.size <= 1000000)
    .test(
      'fileType',
      'Only PNG and JPEG images are allowed',
      value => !value || ['image/png', 'image/jpeg'].includes(value.type)
    );
};

export const formSchema = t => {
  return Yup.object().shape({
    NAME2: Yup.string()
      .trim()
      .required(() => t('Required')),
    NAME: Yup.string()
      .trim()
      .required(() => t('Required')),
    // NATIONAL_IDENTIFIER: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),
    // .max(9999999999, 'must be no more than 10 digits'),
    START_DATE: Yup.date().required(() => t('Required')),
    DATE_OF_BIRTH: Yup.date().required(() => t('Required')),
    // MARITAL_STATUS: Yup.string()
    //   .notOneOf(["إختر", "Choose"], "Required")
    //   .required(() => t("Required")),
    // NATIONALITY: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // TITLE: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // COUNTRY_OF_BIRTH: Yup.string()
    //   // .notOneOf(["إختر", "Choose"], "Required")
    //   .required(() => t("Required")),
    // TOWN_OF_BIRTH: Yup.string().required('Required'),
    // GENDER: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    Religion: Yup.string().required(() => t('Required'))
  });
};

export const EditPersonSchema = t => {
  return Yup.object().shape({
    NAME2: Yup.string()
      .trim()
      .required(() => t('Required')),
    NAME: Yup.string()
      .trim()
      .required(() => t('Required')),
    // NATIONAL_IDENTIFIER: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),
    START_DATE: Yup.date().required(() => t('Required')),
    DATE_OF_BIRTH: Yup.date().required(() => t('Required')),
    // MARITAL_STATUS: Yup.string()
    //   .notOneOf(["إختر", "Choose"], "Required")
    //   .required(() => t("Required")),
    // NATIONALITY: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // TITLE: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // COUNTRY_OF_BIRTH: Yup.string()
    //   // .notOneOf(["إختر", "Choose"], "Required")
    //   .required(() => t("Required")),
    // TOWN_OF_BIRTH: Yup.string().required("Required"),
    // GENDER: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    Religion: Yup.string().required(() => t('Required'))
  });
};

export const AssignmentFormSchema = t => {
  return Yup.object().shape({
    gradeId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    positionId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    jobId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    assignmentStatusTypeId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    payrollId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    locationId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    supervisorId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    organizationId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    personGroupId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required('Required'),

    startDate: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format'))

    // endDate: Yup.date()
    // .required(() => t("Required"))
    // .typeError(() => t("Invalid date format"))
    // // .min(Yup.ref('dateStart'), () => t("يجب ان يكون أكبر ....")),
  });
};

export const formJob = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()

      .required(() => t('Required')),
    name: Yup.string()
      .trim()

      .required(() => t('Required')),
    code: Yup.string()
      .trim()

      .required(() => t('Required')),
    comments: Yup.string().trim()
    // .min(2, "الاسم صغير جدا | the name is too long")
    // .max(50, "الاسم كبير جدا | the name is too long")
    // .required(() => t("Required")),
  });
};

export const formGpoupEmp = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      // .min(5, "الاسم صغير جدا | the name is too short")
      // .max(250, "الاسم كبير جدا | the name is too long")
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      // .min(5, "الاسم صغير جدا | the name is too long")
      // .max(50, "الاسم كبير جدا | the name is too long")
      .required(() => t('Required')),

    // businessGroupId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required(),

    comments: Yup.string().trim()
    // .min(2, "الاسم صغير جدا | the name is too long")
    // .max(50, "الاسم كبير جدا | the name is too long")
    // .required(() => t("Required")),
  });
};

export const formOrganization = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    locationId: Yup.string().required(() => t('Required')),
    type: Yup.string().required(() => t('Required')),
    dateFrom: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid Date'))

    // vatNumber: Yup.number()
    //   .typeError(t('VAT code must be a number'))
    //   // .required(() => t('Required'))
    //   .test(
    //     'len',
    //     t('VAT code must be exactly 15 digits'),
    //     (value) => value && String(value).length === 15
    //   ),

    // commercialRegistrationNumber: Yup.number()
    //   .typeError(t('company Registration Number  must be a number'))
    //   // .required(() => t('Required'))
    //   .test(
    //     'len',
    //     t('company RegistrationNumber must be exactly 10 digits'),
    //     (value) => value && String(value).length === 10
    //   ),
  });
};

export const formLocation = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .min(5, 'الاسم صغير جدا | the name is too short')
      .max(250, 'الاسم كبير جدا | the name is too long')
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .min(5, 'الاسم صغير جدا | the name is too long')
      .max(50, 'الاسم كبير جدا | the name is too long')
      .required(() => t('Required')),

    // businessGroupId: Yup.string().required(() => t("Required")),

    // shipToLocationId: Yup.string().required(() => t("Required")),

    country: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const formPosition = t => {
  return Yup.object().shape({
    jobId: Yup.string()
      .required(() => t('Required'))
      .notOneOf(['إختر', 'Choose'], 'Required'),
    organizationId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    locationId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    headcount: Yup.number()
      .typeError(t('Invalid number')) // Message for non-numeric input
      .required(t('Required')) // Message for empty field
      .integer(t('Only integer values are allowed')) // Ensure the value is an integer
      .positive(t('Only positive numbers are allowed')) // Ensure it's a positive integer
  });
};

export const FormPayrollElement = (t, existingCodes) => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    classificationId: Yup.string().required(() => t('Required')),
    uom: Yup.string().required(() => t('Required')),

    // code: Yup.string().required(() => t('Required')),

    code: Yup.string()
      .trim()
      .matches(/^[A-Za-z0-9_]+$/, t('OnlyEnglishLettersAndSomeSymbolsAreAllowed'))
      .required(() => t('Required'))
      .test('is-unique', t('Code Already Exists'), value => {
        if (!value) return true; // إذا كانت القيمة فارغة، لا داعي للتحقق
        const lowerCaseValue = value?.toLowerCase().trim(); // تحويل القيمة المدخلة إلى أحرف صغيرة
        const lowerCaseExistingNames = existingCodes?.map(name => name?.toLowerCase()); // تحويل الأسماء الموجودة إلى أحرف صغيرة
        return !lowerCaseExistingNames?.includes(lowerCaseValue); // التحقق من عدم التكرار
      })
  });
};

export const FormAddPayrollSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    // businessGroupId: Yup.string()
    // .notOneOf(["إختر", "Choose"], "Required")
    // .required(() => t("Required")),

    paymentMethodId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    periodType: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    startDate: Yup.date().required(() => t('Required')),

    endDate: Yup.date().required(() => t('Required')),
    cutOffDate: Yup.string().required(() => t('Required')),

    numberOfYears: Yup.number().required(() => t('Required')),

    accountId: Yup.string().required(() => t('Required'))
    // ledgerId: Yup.string().required(() => t('Required'))
  });
};
export const PayrollConditionsSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    code: Yup.string()
      .trim()
      .required(() => t('Required'))
      .matches(/^\S+$/, t('CodeCannotContainSpaces')),

    parameterOne: Yup.string()
      .trim()
      .required(() => t('Required')),
    staticType: Yup.string().required(() => t('Required')),

    payrollId: Yup.string().required(() => t('Required'))
  });
};

export const DynamicFormSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    //  urlStaticForm: Yup.string()
    //     .required(() => t("Required")),

    id: Yup.string().when('isStatic', {
      is: true,
      then: () => Yup.string().required(() => t('Required'))
    })
  });
};

export const DynamicFormRecordSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    // tableId: Yup.string().required(() => t("Required")),
    icon: Yup.string().required(() => t('Required')),

    tableId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    moduleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};
export const DynamicFormExtraInfoSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    tableId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    moduleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const DynamicFormAmeSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    moduleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    IdStaticForm: Yup.string().when('isStatic', {
      is: true,
      then: () => Yup.string().required(() => t('Required'))
    })
  });
};
export const AmeConditionSchema = t => {
  return Yup.object().shape({
    name2: Yup.string().required(() => t('Required')),
    name: Yup.string().required(() => t('Required')),
    Condition: Yup.string().required(() => t('Required')),
    // dynamicFormColumnID: Yup.string().required(() => 'مطلوب'),
    dynamicFormColumnID: Yup.string().when('conditionType', {
      is: val => val === 'STATIC',
      then: () => Yup.string().notRequired()
      // otherwise: Yup.string().nullable(),
    }),

    multiSelect: Yup.string().when(['formatType', 'conditionType'], {
      is: (formatType, conditionType) => formatType === 'T' || formatType === 'D' || conditionType === 'STATIC',
      then: () => Yup.string().required(() => t('Required'))
    }),

    includeLowerLimit: Yup.string().when(['validationType', 'conditionType'], {
      is: (val, val2) => (val === 'TIME' || val === 'DATE' || val === 'NUMBER') && val2 !== 'STATIC',
      then: () => Yup.string().required(() => t('Required'))
    }),

    param1: Yup.string().when('includeLowerLimit', {
      is: val => val,
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().notRequired()
    })
  });
};

export const AddUpdateDashboardSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    moduleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const EditDynamicFormSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      // .min(5, "الاسم صغير جدا | the name is too short")
      // .max(250, "الاسم كبير جدا | the name is too long")
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddAmeDelegateSchema = t => {
  return Yup.object().shape({
    selectedPersonId: Yup.string()
      .trim()
      .required(() => t('Required')),
    startDate: Yup.string()
      .trim()
      .required(() => t('Required')),
    endDate: Yup.string()
      .trim()
      .required(() => t('Required')),
    reason: Yup.string()
      .trim()
      .required(() => t('Required'))

    // creatorPersonId: '',
  });
};

export const AddFlexValueSetSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required'))
    // tableName: Yup.string()
    // .notOneOf(["إختر", "Choose"], "Required")
    // .required(() => t("Required")),
  });
};

export const AddFormColumnSchema = t => {
  return Yup.object().shape({
    lable: Yup.string()
      .trim()
      .required(() => t('Required')),
    lable2: Yup.string()
      .trim()
      .required(() => t('Required')),
    sequenceNum: Yup.number().required(() => t('Required')),
    flexValueSetId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const AddFlexValueDynamicSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    tableId: Yup.string().when('radioValue', {
      is: 'T',
      then: () => Yup.string().required(() => t('Required'))
    }),

    lookupType: Yup.string().when('radioValue', {
      is: 'L',
      then: () => Yup.string().required(() => t('Required'))
    }),

    lookupCode: Yup.string().when('tableId', {
      is: value => ['045a58ed-782f-4b4f-a33e-4ffcee9e80f3', '6121dd5c-aa4c-4832-a561-3fdfd0e15ba4'].includes(value),
      then: () => Yup.string().required(() => t('Required'))
    })
  });
};

export const formAddUserSchema = (t, existingUserNames) => {
  return Yup.object().shape({
    usersName: Yup.string()
      .trim()
      // .matches(/^[A-Za-z]+$/, t('OnlyEnglishLettersAreAllowed'))
      .matches(/^[A-Za-z0-9]+$/, t('OnlyEnglishLettersAreAllowed'))
      .required(() => t('Required'))
      .test('is-unique', t('UsernameAlreadyExists'), value => {
        if (!value) return true; // إذا كانت القيمة فارغة، لا داعي للتحقق
        const lowerCaseValue = value?.toLowerCase(); // تحويل القيمة المدخلة إلى أحرف صغيرة
        const lowerCaseExistingNames = existingUserNames?.map(name => name?.toLowerCase()); // تحويل الأسماء الموجودة إلى أحرف صغيرة
        return !lowerCaseExistingNames?.includes(lowerCaseValue); // التحقق من عدم التكرار
      }),

    // emailAddress: Yup.string().trim().email(() => t("ايمبل غير صالح")),

    referenceId: Yup.string().required(() => t('Required')),

    // usersMobile: Yup.string().matches(
    //   /^([+][0-9]{1,3}[-\s]?|[0][-\s]?|[0-9]{2,4}[-\s]?)[0-9]{7,14}$/,
    //   () => t("رقم جوال غير صالح")
    // ),
    userType: Yup.string().required(() => t('Required')),
    // .notOneOf(['إختر', 'Choose'], 'Required'),

    // startDate: Yup.string().required(() => t("Required")),
    // endDate: Yup.string().required(() => t("Required")),

    startDate: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format'))

    // endDate: Yup.date()
    //   .required(() => t("Required"))
    //   .typeError(() => t("Invalid date format"))
    //   .min(Yup.ref("startDate"), () => t("يجب ان يكون اكبر من تاريخ البدء")),

    // startDate: Yup.date()
    // .required(() => t("Required"))
    // .typeError(() => t("Invalid date format")),

    // endDate: Yup.date()
    // .required(() => t("Required"))
    // .typeError(() => t("Invalid date format"))
    // .min(Yup.ref('startDate'), () => t("يجب ان يكون أكبر ....")),
  });
};

export const formAuthRulesSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    startDate: Yup.string().required(() => t('Required')),

    moduleId: Yup.string()
      .required(() => t('Required'))
      .notOneOf(['إختر', 'Choose'], 'Required')
  });
};

export const AddPayProposalSchema = t => {
  return Yup.object().shape({
    proposedSalaryN: Yup.number()
      .typeError('Please enter a valid number')
      .required(() => t('Required')),

    proposalReason: Yup.string().required(() => t('Required')),

    changeDate: Yup.string().required(() => t('Required'))
  });
};

export const AddPayrollElementEntrySchema = t => {
  return Yup.object().shape({
    elementLinkId: Yup.string().required(() => t('Required')),

    // elementTypeId: Yup.string()
    // .required(() => t("Required"))
    // .notOneOf(["إختر", "Choose"], "Required"),

    screenEntryValue: Yup.string().required(() => t('Required')),

    startDate: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format')),

    endDate: Yup.date().when('isRecurring', {
      is: false,
      then: () =>
        Yup.date()
          .required(() => t('Required'))
          .typeError(() => t('Invalid date format'))
          .min(Yup.ref('startDate'), () => t('يجب ان يكون أكبر ....'))
    })
  });
};

export const formAbsenseSchema = t => {
  return Yup.object().shape({
    // authorisingPersonId: Yup.string().required(() => t('Required')),

    // authorisingPersonId: Yup.string().when('isAme', {
    //   is: false,
    //   then:
    //     Yup.string()
    //       .notOneOf(['إختر', 'Choose'], 'Required')
    //       .required(() => t('Required')),
    // }),

    replacementPersonId: Yup.string().required(() => t('Required')),

    // absenceAttendanceTypeId: Yup.string().required("نوع الغياب مطلوب"), // Example validation rule for GUID select field

    absenceAttendanceTypeId: Yup.string().required(() => t('Required')),

    dateStart: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format')),

    dateEnd: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format'))
      .min(Yup.ref('dateStart'), () => t('يجب ان يكون أكبر ....'))
  });
};

export const EndOfServiceFormSchema = t => {
  return Yup.object().shape({
    personId: Yup.string().required(() => t('Required')),
    dateStart: Yup.string().required(() => t('Required')),
    acceptedTerminationDate: Yup.string().required(() => t('Required')),
    actualTerminationDate: Yup.string().required(() => t('Required')),
    finalProcessDate: Yup.string().required(() => t('Required')),
    leavingReason: Yup.string().required(() => t('Required')),
    notifiedTerminationDate: Yup.string().required(() => t('Required')),

    // periodsOfServiceTypeId: Yup.string().required(() => t('Required')),
    periodsOfServiceTypeId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
    // dateStart: Yup.date()
    //   .required(() => t('Required'))
    //   .typeError(() => t('Invalid date format')),

    // dateEnd: Yup.date()
    //   .required(() => t('Required'))
    //   .typeError(() => t('Invalid date format'))
    //   .min(Yup.ref('dateStart'), () => t('يجب ان يكون أكبر ....')),
  });
};

export const formRaqeebSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    startDate: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format')),

    endDate: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format'))
      .min(Yup.ref('startDate'), () => t('يجب ان يكون أكبر ....'))
  });
};

export const AttendanceAdjustmentSchema = t => {
  return Yup.object().shape({
    personId: Yup.string()
      .trim()
      .required(() => t('Required')),

    attendenceAdjustmentType: Yup.string()
      .trim()
      .required(() => t('Required')),
    // reason: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),

    // startDateTime: Yup.date()
    //   .required(() => t('Required'))
    //   .typeError(() => t('Invalid date format')),
    // endDateTime: Yup.date()
    //   .required(() => t('Required'))
    //   .typeError(() => t('Invalid date format')),

    startDateTime: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format')),

    endDateTime: Yup.date()
      .required(() => t('Required'))
      .typeError(() => t('Invalid date format'))
      .min(Yup.ref('startDateTime'), () => t('End date must be after start date'))
  });
};

export const AddFlexValueSchema = t => {
  return Yup.object().shape({
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    parentId: Yup.string().required(() => t('Required'))

    // .notOneOf(["إختر", "Choose"], "Required"),
  });
};

export const AddRealEstateSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    code: Yup.string(),

    annual_rent: Yup.number()
      .typeError('Capacity must be a valid number')
      .required(() => t('Required')),

    watermeter: Yup.string().required(() => t('Required')),

    gascounter: Yup.string().required(() => t('Required')),

    electricitymeter: Yup.string().required(() => t('Required')),

    attitudesmeter: Yup.string().required(() => t('Required')),

    number_meter: Yup.number()
      .typeError('Capacity must be a valid number')
      .required(() => t('Required')),

    capacity: Yup.number()
      .typeError('Capacity must be a valid number')
      .required(() => t('Required')),

    realEstateTypeId: Yup.string().required(() => t('Required')),

    parent_id: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    organizationId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const AddLookupSchema = t => {
  return Yup.object().shape({
    meaning2: Yup.string()
      .trim()
      .required(() => t('Required')),
    meaning: Yup.string()
      .trim()
      .required(() => t('Required')),
    lookupCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    lookupType: Yup.string().required(() => t('Required')),
    description: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddContractSchema = t => {
  return Yup.object().shape({
    organization_id: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    contract_status: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    code: Yup.string().required(() => t('Required')),

    contrcat_date: Yup.date().required(() => t('Required')),

    purpose: Yup.string().required(() => t('Required')),

    annual_rent: Yup.number().required(() => t('Required')),

    amount_insurance: Yup.number().required(() => t('Required')),
    contract_period: Yup.string().required(() => t('Required')),
    period_from_date: Yup.date().required(() => t('Required')),
    period_to_date: Yup.date().required(() => t('Required')),

    payment_type: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    amount_services: Yup.number().required(() => t('Required')),
    fees_office: Yup.number().required(() => t('Required')),

    represented: Yup.string().required(() => t('Required')),
    installment_count: Yup.number().required(() => t('Required'))
  });
};

export const AddEquipmentsModelFLeetSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddWorkShopFLeetSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    name2: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const EquipmentsSchema = t => {
  return Yup.object().shape({
    // name: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    chassisNo: Yup.string()
      .trim()
      .required(() => t('Required')),
    // name2: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    code: Yup.string()
      .trim()
      .required(() => t('Required')),
    // barcode: Yup.string().required(() => t("Required")),
    // serviceDate: Yup.string().required(() => t('Required')),
    // dateOfExpiry: Yup.string().required(() => t('Required')),
    // lastmaintenanceDate: Yup.string().required(() => t("Required")),

    plateNo: Yup.string()
      .trim()
      .required(() => t('Required')),
    serialNo: Yup.string()
      .trim()
      .required(() => t('Required')),
    odometer: Yup.number()
      .typeError('must be a number')
      .required(() => t('Required'))
      .max(9999999999, 'must be no more than 10 digits'),
    purchasePrice: Yup.number()
      .typeError('must be a number')
      // .required(() => t("Required"))
      .max(9999999999, 'must be no more than 10 digits'),

    fleetModelId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    organizationId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))

    // engineStatus: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required'))
  });
};

export const EquipmentHandOverSchema = t => {
  return Yup.object().shape({
    deliveryDateFrom: Yup.string().required(() => t('Required')),
    // odometer: Yup.min(1).required(() => t('Required')),

    peopleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};
export const EquipmentTakeOverSchema = t => {
  return Yup.object().shape({
    DeliveryDateTo: Yup.string().required(() => t('Required')),
    // odometer: Yup.min(1).required(() => t('Required')),

    odometer: Yup.string().required(() => t('Required'))
  });
};

export const EquipmentRoutesSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    startTime: Yup.string().required(() => t('Required')),
    endTime: Yup.string().required(() => t('Required'))
  });
};

export const EquipmentsOdometerSchema = t => {
  return Yup.object().shape({
    odometer: Yup.number().required(() => t('Required')),
    readDate: Yup.string()
      .trim()
      .required(() => t('Required')),

    peopleId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};
export const NtxPeopleSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    vatCode: Yup.string() // استخدم string بدلاً من number لتجنب مشاكل التحويل
      .trim()
      .nullable()
      .notRequired()
      .matches(/^\d*$/, t('VAT code must be a number'))
      .test('len', t('VAT code must be exactly 15 digits'), value => !value || value.length === 15),

    companyRegistrationNumber: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .matches(/^\d*$/, t('Company Registration Number must be a number'))
      .test('len', t('Company Registration Number must be exactly 10 digits'), value => !value || value.length === 10)

    // vatCode: Yup.number()
    //   .typeError(t('VAT code must be a number'))
    //   .required(() => t('Required'))
    //   .test('len', t('VAT code must be exactly 15 digits'), value => value && String(value).length === 15),

    // companyRegistrationNumber: Yup.number()
    //   .typeError(t('company Registration Number  must be a number'))
    //   .required(() => t('Required'))
    //   .test(
    //     'len',
    //     t('company RegistrationNumber must be exactly 10 digits'),
    //     value => value && String(value).length === 10
    //   )
  });
};
export const SupplierSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    termsId: Yup.string()
      .trim()
      .required(() => t('Required')),
    accountId: Yup.string()
      .trim()
      .required(() => t('Required')),

    paymentMethodId: Yup.string()
      .trim()
      .required(() => t('Required')),

    peopleType: Yup.string()
      .trim()
      .required(() => t('Required')),

    personId: Yup.string().when('peopleType', {
      is: 'EMPLOYEE',
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    vatCode: Yup.string() // استخدم string بدلاً من number لتجنب مشاكل التحويل
      .trim()
      .nullable()
      .notRequired()
      .matches(/^\d*$/, t('VAT code must be a number'))
      .test('len', t('VAT code must be exactly 15 digits'), value => !value || value.length === 15),

    companyRegistrationNumber: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .matches(/^\d*$/, t('Company Registration Number must be a number'))
      .test('len', t('Company Registration Number must be exactly 10 digits'), value => !value || value.length === 10)
  });
};
export const CustomerSchema = t => {
  return Yup.object().shape({
    // name: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    invoiceCurrencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),

    termsId: Yup.string()
      .trim()
      .required(() => t('Required')),

    paymentMethodId: Yup.string()
      .trim()
      .required(() => t('Required')),

    priceListId: Yup.string()
      .trim()
      .required(() => t('Required')),

    accountId: Yup.string()
      .trim()
      .required(() => t('Required')),

    // vatCode: Yup.string() // استخدم string بدلاً من number لتجنب مشاكل التحويل
    //   .trim()
    //   .nullable()
    //   .notRequired()
    //   .matches(/^\d*$/, t('VAT code must be a number'))
    //   .test('len', t('VAT code must be exactly 15 digits'), value => !value || value.length === 15),

    companyRegistrationNumber: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .matches(/^\d*$/, t('Company Registration Number must be a number'))
      .test('len', t('Company Registration Number must be exactly 10 digits'), value => !value || value.length === 10),

    street: Yup.string()
      .trim()
      .required(() => t('Required')),

    district: Yup.string()
      .trim()
      .required(() => t('Required')),

    city: Yup.string()
      .trim()
      .required(() => t('Required')),

    buildingNumber: Yup.string()
      .trim()
      .required(() => t('Required')),

    postalCode: Yup.string()
      .trim()
      .required(() => t('Required')),

    vatCode: Yup.number()
      .typeError(t('VAT code must be a number'))
      .required(() => t('Required'))
      .test('len', t('VAT code must be exactly 15 digits'), value => value && String(value).length === 15)

    // companyRegistrationNumber: Yup.number()
    //   .typeError(t('company Registration Number  must be a number'))
    //   .required(() => t('Required'))
    //   .test(
    //     'len',
    //     t('company RegistrationNumber must be exactly 10 digits'),
    //     value => value && String(value).length === 10
    //   )
  });
};

export const EquipmentsWorkRequestSchema = t => {
  return Yup.object().shape({
    // requestCode: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    requestDate: Yup.string().required(() => t('Required')),
    requestTitle: Yup.string()
      .trim()
      .required(() => t('Required')),
    personId: Yup.string().required(() => t('Required')),
    // source: Yup.string().required(() => t("Required")),

    // phone: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),

    priority: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    requestType: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    organizationId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    fleetEquipmentsId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const EquipmentsModelSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    // barcode: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),

    parentId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    // manufYear: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    catagory: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    // manufCountry: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    // .required(() => t('Required')),
    // fuelType: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // motionVector: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),
    // horsepowerTax: Yup.number().typeError('must be a number'),
    // horsepower: Yup.number().typeError('must be a number'),
    // doorsNo: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),
    // seatsNo: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),

    Img: createImgValidation()
  });
};

export const EquipmentsWorkOrderSchema = t => {
  return Yup.object().shape({
    // orderCode: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    odometer: Yup.number().required(() => t('Required')),
    startDateSugg: Yup.string().required(() => t('Required')),
    endDateSugg: Yup.string().required(() => t('Required')),

    // totalItems: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),
    // totalAsset: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),
    // otherAmounts: Yup.number()
    //   .typeError('must be a number')
    //   .required(() => t('Required')),

    fleetEquipmentsId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    workshopId: Yup.string().when('isInternal', {
      is: '1',
      then: () =>
        Yup.string()
          .notOneOf(['إختر', 'Choose'], 'Required')
          .required(() => t('Required'))
    }),

    supplierId: Yup.string()
      .nullable()
      .when('isInternal', {
        is: '0',
        then: () =>
          Yup.string()
            .notOneOf(['إختر', 'Choose'], 'Required')
            .required(() => t('Required'))
      }),

    // equipmentsWorkOrderItemList: Yup.array().of(
    //   Yup.object().shape({
    //     itemId: Yup.string().required(() => t('Required')),
    //     uom: Yup.string().required(() => t('Required')),

    //     qty: Yup.number().min(1, 'Quantity must be at least 1').required()
    //   })
    // ),

    equipmentsWorkOrderItemList: Yup.array().when('isInternal', {
      is: '1', // مطلوب فقط إذا كانت داخلية
      then: () =>
        Yup.array().of(
          Yup.object().shape({
            itemId: Yup.string().required(() => t('Required')),
            uom: Yup.string().required(() => t('Required')),
            qty: Yup.number()
              .min(1, 'Quantity must be at least 1')
              .required(() => t('Required'))
          })
        ),
      otherwise: () => Yup.array().nullable() // غير مطلوب عند isInternal = '0'
    }),

    // equipmentsWorkOrderPersonList: Yup.array().of(
    //   Yup.object().shape({
    //     personId: Yup.string().required(() => t('Required'))
    //   })
    // )

    // ✅ مطلوب فقط عند isInternal = '1'
    equipmentsWorkOrderPersonList: Yup.array().when('isInternal', {
      is: '1',
      then: () =>
        Yup.array().of(
          Yup.object().shape({
            personId: Yup.string().required(() => t('Required'))
          })
        ),
      otherwise: () => Yup.array().nullable()
    })
  });
};

export const UpdateWorkOrderSchema = t => {
  return Yup.object().shape({
    dateCompletion: Yup.string().required(() => t('Required')),
    startDateExecution: Yup.string().required(() => t('Required')),
    noteCompletion: Yup.string().required(() => t('Required')),
    endDateExecution: Yup.string().required(() => t('Required')),

    totalBudgetActual: Yup.number()
      .typeError('must be a number')
      .required(() => t('Required')),
    otherAmountsActual: Yup.number()
      .typeError('must be a number')
      .required(() => t('Required')),
    totalAssetActual: Yup.number()
      .typeError('must be a number')
      .required(() => t('Required')),
    totalItemsActual: Yup.number()
      .typeError('must be a number')
      .required(() => t('Required'))
  });
};

export const InstallmentPaymentSchema = t => {
  return Yup.object().shape({
    paymentDate: Yup.string().required(() => t('Required')),

    PaymentMethodId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    bankReference: Yup.string().when('PaymentMethodId', {
      is: val => val !== '05fe55ee-ade9-4b4b-85f9-c1dbacf40a6b',
      then: () => Yup.string().required(() => t('Required'))
    }),

    // currencyId: Yup.string()
    // .notOneOf(["إختر", "Choose"], "Required")
    // .required(() => t("Required")),

    bankId: Yup.string().when('PaymentMethodId', {
      is: val => val !== '05fe55ee-ade9-4b4b-85f9-c1dbacf40a6b',
      then: () =>
        Yup.string()
          .notOneOf(['إختر', 'Choose'], 'Required')
          .required(() => t('Required'))
    })
  });
};

export const AddFleetElementSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    description: Yup.string().required(() => t('Required')),
    description2: Yup.string().required(() => t('Required')),
    sort: Yup.string().required(() => t('Required')),

    catagory: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),
    priority: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const CategoriesINVSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    icon: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
    // categoryId: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required'))
  });
};
export const EditCategoriesINVSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    icon: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const AddFleetInspectionSchema = t => {
  return Yup.object().shape({
    scanningDate: Yup.string().required(() => t('Required')),
    // description: Yup.string().required(() => t("Required")),

    driverId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    details: Yup.array().of(
      Yup.object({
        value: Yup.boolean().required(() => t('Required'))
      })
    )
  });
};

export const SubInventorySchema = t => {
  return Yup.object().shape({
    name: Yup.string().required(() => t('Required')),
    name2: Yup.string().required(() => t('Required')),
    code: Yup.string().required(() => t('Required'))

    // parentId: '',
    // description: '',
  });
};

//#region  Finance Form Schema

export const AddGlJeHeaderSchema = t => {
  return Yup.object().shape({
    glDate: Yup.string().required(() => t('Required')),
    // jeBatchId: Yup.string().required(() => t("Required")),
    // parentJeHeaderId: Yup.string().required(() => t("Required")),

    // currencyConversionRate: Yup.string().trim().required(() => t("Required")),
    description: Yup.string()
      .trim()
      .required(() => t('Required')),

    jeCategory: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    // jeSource: Yup.string()
    //   .notOneOf(['إختر', 'Choose'], 'Required')
    //   .required(() => t('Required')),

    periodId: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required')),

    currencyCode: Yup.string()
      .notOneOf(['إختر', 'Choose'], 'Required')
      .required(() => t('Required'))
  });
};

export const AddApExpenseCategorySchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    jeCategory: Yup.string()
      .trim()
      .required(() => t('Required')),
    jeSource: Yup.string()
      .trim()
      .required(() => t('Required')),
    expenseAccountId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};
export const AddApExpenseCategoryItemsSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddBankAccountsSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    iban: Yup.string()
      .trim()
      .required(() => t('Required')),

    bankAccount: Yup.string()
      .trim()
      .required(() => t('Required')),
    accountId: Yup.string()
      .trim()
      .required(() => t('Required')),
    ntxBankId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};
export const AddCashBoxesSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    accountId: Yup.string()
      .trim()
      .required(() => t('Required')),
    ntxBankId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddBankSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    code: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddApPaymentsSchema = t => {
  return Yup.object().shape({
    paymentDate: Yup.date()
      .required(() => t('Required'))
      .nullable(),
    // apBankAccountId: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    // paymentMethodId: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),

    paymentMethodId: Yup.string().when('paymentType', {
      is: value => !['b2e01e84-98f9-4d51-9f7f-beec65353953', '45de9a40-acc4-4088-ab2f-3b07b98d3927'].includes(value),
      then: () => Yup.string().required(() => t('Required'))
    }),
    apBankAccountId: Yup.string().when('paymentType', {
      is: value => !['b2e01e84-98f9-4d51-9f7f-beec65353953', '45de9a40-acc4-4088-ab2f-3b07b98d3927'].includes(value),
      then: () => Yup.string().required(() => t('Required'))
    }),
    description: Yup.string()
      .nullable()
      .max(4000, () => t('يجب ألا يتجاوز الوصف 4000 حرف')),

    // amount: Yup.number()
    //   .required(() => t('Required'))
    //   .positive('يجب أن يكون المبلغ أكبر من الصفر')
    //   .min(1, 'يجب أن يكون المبلغ على الأقل 1'),
    currencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    currencyConversionRate: Yup.number()
      .required(() => t('Required'))
      .positive('يجب أن يكون معدل التحويل أكبر من الصفر'),
    peopleId: Yup.string()
      .trim()
      .required(() => t('Required')),
    organizationId: Yup.string()
      .trim()
      .required(() => t('Required')),
    // accountId: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    // costCenterId: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    paymentType: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddArReceiptsSchema = t => {
  return Yup.object().shape({
    depositDate: Yup.date()
      .required(() => t('Required'))
      .nullable(),

    // ✅ نفس منطق AP: لا نطلب طريقة/بنك في حالات Apply (أو حسب IDs التي عندك)
    depositMethodId: Yup.string().when('receiptType', {
      is: value =>
        ![
          // ضع هنا IDs الخاصة بـ ApplyDebitMemo / ApplyPreReceipt عندك (إن كانت receiptType GUID)
          'b2e01e84-98f9-4d51-9f7f-beec65353953',
          '45de9a40-acc4-4088-ab2f-3b07b98d3927'
        ].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    bankAccountId: Yup.string().when('receiptType', {
      is: value =>
        ![
          // نفس القائمة السابقة
          'b2e01e84-98f9-4d51-9f7f-beec65353953',
          '45de9a40-acc4-4088-ab2f-3b07b98d3927'
        ].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    // ✅ الوصف
    description: Yup.string()
      .nullable()
      .max(500, () => t('يجب ألا يتجاوز الوصف 500 حرف')),

    currencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),

    currencyConversionRate: Yup.number()
      .required(() => t('Required'))
      .positive(() => t('يجب أن يكون معدل التحويل أكبر من الصفر')),

    peopleId: Yup.string()
      .trim()
      .required(() => t('Required')),

    organizationId: Yup.string()
      .trim()
      .required(() => t('Required')),

    receiptType: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddPaymentSchedulesSchema = t => {
  return Yup.object().shape({
    paymentDate: Yup.date()
      .required(() => t('Required'))
      .nullable(),
    apBankAccountId: Yup.string()
      .trim()
      .required(() => t('Required')),
    paymentMethodId: Yup.string()
      .trim()
      .required(() => t('Required')),

    amount: Yup.number()
      .required(() => t('Required'))
      .positive('يجب أن يكون المبلغ أكبر من الصفر')
      .min(1, 'يجب أن يكون المبلغ على الأقل 1'),

    currencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    currencyConversionRate: Yup.number()
      .required(() => t('Required'))
      .positive('يجب أن يكون معدل التحويل أكبر من الصفر'),

    paymentType: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddApInvoiceSchema = (t, activeFinance) => {
  return Yup.object().shape({
    invoiceNum: Yup.string()
      .trim()
      .required(() => t('Required')),
    peopleId: Yup.string()
      .trim()
      .required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    invoiceType: Yup.string().required(() => t('Required')),
    // referenceType: Yup.string().required(() => t('Required')),
    // referenceId: Yup.string().required(() => t('Required')),
    invoiceDate: Yup.string().required(() => t('Required')),
    paymentTermsId: Yup.string().required(() => t('Required')),
    paymentMethodId: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    currencyConversionRate: Yup.string().required(() => t('Required')),

    apInvoiceLinesList: Yup.array().of(
      Yup.object().shape({
        invItemId: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),
        uom: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),
        qty: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () =>
            Yup.number()
              .min(1)
              .required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),

        description: Yup.string().when('lineType', {
          is: value => value !== 'Item_Inv',
          then: () =>
            Yup.string()
              .trim()
              .required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),

        lineType: Yup.string().required(() => t('Required')),

        total: Yup.number()
          .positive(() => t('The value must be positive')) // للتأكد من أن القيمة موجبة
          .min(1, () => t('Quantity must be at least 1')) // للتأكد من أن القيمة على الأقل 1
          .required(() => t('Required')), // لجعل الحقل مطلوبًا        // : Yup.number().min(1, 'Quantity must be at least 1').required(),

        // accountId: Yup.string().required(() => t('Required')),
        // costCenterId: Yup.string().required(() => t('Required'))

        // ✅ هنا الشرط الخاص بالمالية
        accountId: activeFinance ? Yup.string().required(() => t('Required')) : Yup.string().nullable(),

        costCenterId: activeFinance ? Yup.string().required(() => t('Required')) : Yup.string().nullable()

        // discountRate: line.discountRate,
        // discountAmount: line.discountAmount,
        // vatRate: line.vatRate,
        // total: line.total,
        // vatAmount: line.vatAmount,
        // accountId: null,
        // costCenterId: null,
        // currencyCode: data.currencyCode ?? '',
        // currencyConversionRate: data.currencyConversionRate ?? '',
        // purHeaderId: data.id ?? '',
        // purLineId: line.id,
        // codeCombination: '',
      })
    ),

    apPaymentSchedulesList: Yup.array().of(
      Yup.object().shape({
        dueDate: Yup.string().required(() => t('Required')),

        amount: Yup.number()
          .positive(() => t('The value must be positive')) // للتأكد من أن القيمة موجبة
          .min(1, () => t('value must be at least 1')) // للتأكد من أن القيمة على الأقل 1
          .required(() => t('Required')) // لجعل الحقل مطلوبًا        // : Yup.number().min(1, 'Quantity must be at least 1').required(),
      })
    )
  });
};

export const CreateAccountSchema = t => {
  return Yup.object().shape({
    glDate: Yup.string()
      .trim()
      .required(() => t('Required')),

    periodId: Yup.string()
      .trim()
      .required(() => t('Required')),

    ledgerId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddApExpanseSchema = t => {
  return Yup.object().shape({
    expenseCategoryId: Yup.string()
      .trim()
      .required(() => t('Required')),
    organizationId: Yup.string()
      .trim()
      .required(() => t('Required')),
    peopleId: Yup.string()
      .trim()
      .required(() => t('Required')),
    personId: Yup.string()
      .trim()
      .required(() => t('Required')),
    expenseDate: Yup.date()
      .required(() => t('Required'))
      .nullable(),
    // description: Yup.string().required(t('حقل الوصف مطلوب')),
    // totalAmount: Yup.number()
    //   .required(() => t('Required'))
    //   .positive(t('يجب أن يكون المبلغ أكبر من 0')),
    // totalVat: Yup.number()
    //   .required(() => t('Required'))
    //   .min(0, t('يجب أن تكون الضريبة أكبر من أو تساوي 0')),
    description: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    currencyConversionRate: Yup.number()
      .required(() => t('Required'))
      .positive(t('يجب أن يكون معدل التحويل أكبر من 0')),

    // ExpensType: Yup.string().oneOf(['FAST', 'NORMAL']).required(t('Required')),
    expensType: Yup.string().oneOf(['FAST', 'NORMAL']).required(t('Required')),

    // PaymentMethodId: Yup.mixed().when('ExpensType', {
    paymentMethodId: Yup.mixed().when('expensType', {
      is: v => v === 'FAST',
      then: s => s.required(t('Required')),
      otherwise: s => s.nullable()
    }),

    apBankAccountId: Yup.mixed().when('expensType', {
      // ApBankAccountId: Yup.mixed().when('ExpensType', {
      is: v => v === 'FAST',
      then: s => s.required(t('Required')),
      otherwise: s => s.nullable()
    }),

    apExpenseLinesList: Yup.array()
      .of(
        Yup.object().shape({
          expenseCategoryItemId: Yup.string().trim().required(t('حقل بند المصروف مطلوب')),
          description: Yup.string().trim().required(t('حقل الوصف مطلوب')),
          amount: Yup.number().required(t('حقل المبلغ مطلوب')).positive(t('يجب أن يكون المبلغ أكبر من 0')),
          vat: Yup.number().required(t('حقل الضريبة مطلوب')).min(0, t('يجب أن تكون الضريبة أكبر من أو تساوي 0'))
        })
      )
      .min(1, t('يجب إضافة سطر واحد على الأقل'))
  });
};

export const FiscalYearSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),

    startDate: Yup.string()
      .trim()
      .required(() => t('Required')),
    endDate: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddLedgersSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    currencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    chartOfAccountsId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const GlPeriodsSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    startDate: Yup.string()
      .trim()
      .required(() => t('Required')),
    endDate: Yup.string()
      .trim()
      .required(() => t('Required')),

    periodYear: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const TaxManagersSchema = t => {
  return Yup.object().shape({
    taxType: Yup.string()
      .trim()
      .required(() => t('Required')),
    accountId: Yup.string()
      .trim()
      .required(() => t('Required')),

    startDateActive: Yup.date().required(() => t('Required')),
    taxRate: Yup.number()
      .typeError(t('الرجاء إدخال قيمة رقمية')) // رسالة توضح أن المدخل يجب أن يكون رقميًا
      .required(t('Required')) // رسالة توضح أن الحقل إلزامي
    // ledgerId: Yup.string()
    //   .trim()
    //   .required(() => t('Required'))
  });
};
export const DailyRatesSchema = t => {
  return Yup.object().shape({
    fromCurrencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    toCurrencyCode: Yup.string()
      .trim()
      .required(() => t('Required')),

    conversionStartDate: Yup.date().required(() => t('Required')),
    conversionRate: Yup.number()
      .typeError(t('الرجاء إدخال قيمة رقمية')) // رسالة توضح أن المدخل يجب أن يكون رقميًا
      .required(t('Required')) // رسالة توضح أن الحقل إلزامي
  });
};

export const PaymentTermsSchema = t => {
  return Yup.object().shape({
    name: Yup.string().required(() => t('Required')), // التحقق من أن الحقل ليس فارغًا
    name2: Yup.string().required(() => t('Required')),
    // description: Yup.string().required(() => t('Required')),
    period: Yup.number()
      .required(() => t('Required'))
      .min(1, 'يجب أن تكون الفترة أكبر من أو تساوي 1') // التحقق من الحد الأدنى للقيمة
      .typeError('الفترة يجب أن تكون رقمية') // التحقق من أن المدخل رقم
  });
};

export const AddArTransactionSchema = (t, activeFinance) => {
  return Yup.object().shape({
    salesrepId: Yup.string()
      .trim()
      .required(() => t('Required')),
    billToCustomerId: Yup.string()
      .trim()
      .required(() => t('Required')),
    shipToCustomerId: Yup.string()
      .trim()
      .required(() => t('Required')),

    transactionNum: Yup.string()
      .trim()
      .required(() => t('Required')),

    peopleId: Yup.string()
      .trim()
      .required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    transactionType: Yup.string().required(() => t('Required')),

    transactionDate: Yup.string().required(() => t('Required')),
    paymentTermsId: Yup.string().required(() => t('Required')),
    paymentMethodId: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    currencyConversionRate: Yup.string().required(() => t('Required')),

    arTransactionLinesList: Yup.array().of(
      Yup.object().shape({
        invItemId: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),
        uom: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),
        qty: Yup.string().when('lineType', {
          is: 'Item_Inv',
          then: () =>
            Yup.number()
              .min(1)
              .required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),

        description: Yup.string().when('lineType', {
          is: value => value !== 'Item_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),

        lineType: Yup.string().required(() => t('Required')),

        total: Yup.number()
          .positive(() => t('The value must be positive')) // للتأكد من أن القيمة موجبة
          .min(1, () => t('Quantity must be at least 1')) // للتأكد من أن القيمة على الأقل 1
          .required(() => t('Required')), // لجعل الحقل مطلوبًا        // : Yup.number().min(1, 'Quantity must be at least 1').required(),

        // accountId: Yup.string().required(() => t('Required')),
        // costCenterId: Yup.string().required(() => t('Required'))

        // ✅ هنا الشرط الخاص بالمالية
        accountId: activeFinance ? Yup.string().required(() => t('Required')) : Yup.string().nullable(),
        costCenterId: activeFinance ? Yup.string().required(() => t('Required')) : Yup.string().nullable()

        // discountRate: line.discountRate,
        // discountAmount: line.discountAmount,
        // vatRate: line.vatRate,
        // total: line.total,
        // vatAmount: line.vatAmount,
        // accountId: null,
        // costCenterId: null,
        // currencyCode: data.currencyCode ?? '',
        // currencyConversionRate: data.currencyConversionRate ?? '',
        // purHeaderId: data.id ?? '',
        // purLineId: line.id,
        // codeCombination: '',
      })
    ),

    arReceiptSchedulesList: Yup.array().of(
      Yup.object().shape({
        dueDate: Yup.string().required(() => t('Required')),

        amount: Yup.number()
          .positive(() => t('The value must be positive')) // للتأكد من أن القيمة موجبة
          .min(1, () => t('value must be at least 1')) // للتأكد من أن القيمة على الأقل 1
          .required(() => t('Required')) // لجعل الحقل مطلوبًا        // : Yup.number().min(1, 'Quantity must be at least 1').required(),
      })
    )
  });
};

//#endregion

export const AddIssueTransactionsSchema = t => {
  return Yup.object().shape({
    code: Yup.string().required(() => t('Required')),
    branchId: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    // personId: Yup.string().required(() => t('Required')),
    subInventoryId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),

    // referenceId: Yup.string().required(() => t('Required')),
    // supplierId: Yup.string().required(() => t('Required')),
    referenceId: Yup.string().required(() => t('Required')),

    // referenceId: Yup.string().when('code', {
    //   is: value => ['SPR', 'WOI', 'IOI', 'CCA', 'SOI', 'INV', 'MOI'].includes(value),
    //   then: () => Yup.string().required(() => t('Required')),
    //   otherwise: () => Yup.string().nullable()
    // }),

    supplierId: Yup.string().when('code', {
      is: value => ['SPR'].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    customerId: Yup.string().when('code', {
      is: value => ['SOI', 'INV'].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    materialTransactionsLineList: Yup.array().of(
      Yup.object().shape({
        // transactionQuantityOut: 0,

        transactionItemId: Yup.string().required(() => t('Required')),
        transactionUom: Yup.string().required(() => t('Required')),

        transactionQuantityIn: Yup.number().min(1, 'Quantity must be at least 1').required()
      })
    )
  });
};
export const AddReceiveTransactionsSchema = t => {
  return Yup.object().shape({
    code: Yup.string().required(() => t('Required')),
    branchId: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    // personId: Yup.string().required(() => t('Required')),
    subInventoryId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),
    referenceId: Yup.string().required(() => t('Required')),

    // referenceId: Yup.string().when('code', {
    //   is: value => !['MIR'].includes(value),
    //   then: () => Yup.string().required(() => t('Required')),
    //   otherwise: () => Yup.string().nullable()
    // }),

    supplierId: Yup.string().when('code', {
      is: value => ['POR'].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    supplierInvoiceNum: Yup.string().when('code', {
      is: value => ['POR'].includes(value),
      then: () => Yup.string().required(() => t('Required'))
      // otherwise: () => Yup.string().nullable()
    }),

    customerId: Yup.string().when('code', {
      is: value => ['CRT'].includes(value),
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().nullable()
    }),

    materialTransactionsLineList: Yup.array().of(
      Yup.object().shape({
        // transactionQuantityOut: 0,

        transactionItemId: Yup.string().required(() => t('Required')),
        transactionUom: Yup.string().required(() => t('Required')),

        transactionQuantityIn: Yup.number().min(1, 'Quantity must be at least 1').required()
        // unitPrice: Yup.number().min(1, 'Quantity must be at least 1').required()
      })
    )
  });
};

export const AddAllocatTransactionsSchema = t => {
  return Yup.object().shape({
    // code: Yup.string().required(() => t('Required')),
    branchId: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    subInventoryId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),

    materialTransactionsLineList: Yup.array().of(
      Yup.object().shape({
        transactionItemId: Yup.string().required(() => t('Required')),
        transactionUom: Yup.string().required(() => t('Required')),
        transactionQuantityIn: Yup.number().min(1, 'Quantity must be at least 1').required()
      })
    )
  });
};

// export const AddMoveTransactionsSchema = t => {
//   return Yup.object().shape({
//     // رأس المستند
//     code: Yup.string().required(() => t('Required')),

//     transactionDate: Yup.date().required(() => t('Required')),

//     branchId: Yup.string().required(() => t('Required')),
//     inventoryId: Yup.string().required(() => t('Required')),

//     // وجهة التحويل (مطلوبة عندك لأن التشييك قبل الحفظ يعتمد عليها)
//     branchTo: Yup.string().required(() => t('Required')),
//     inventoryTo: Yup.string().required(() => t('Required')),

//     // اختياري (لأنك حالياً لا تختاره من الواجهة)
//     subInventoryId: Yup.mixed().nullable(),
//     subInventoryTo: Yup.mixed().nullable(),

//     // طريقة التحويل (Direct / InDirect) حسب شاشتك الحالية اختيارية
//     referenceType: Yup.string().nullable(),

//     // ✅ طريقة التسعير: 1=سعر تلقائي من التكلفة, 2=سعر يدوي
//     methodTransfer: Yup.number()
//       .required(() => t('Required'))
//       .oneOf([1, 2], () => t('Required')),

//     // البنود
//     materialTransactionsLineList: Yup.array()
//       .required(() => t('Required'))
//       .min(1, () => t('Required'))
//       .of(
//         Yup.object().shape({
//           transactionItemId: Yup.string().required(() => t('Required')),
//           transactionUom: Yup.string().required(() => t('Required')),

//           transactionQuantityIn: Yup.number()
//             .typeError(() => t('Required'))
//             .moreThan(0, () => t('Required'))
//             .required(() => t('Required')),

// // unitPrice: Yup.mixed().when('methodTransfer', {
// //   is: (value) => value === 2,
// //   then: () =>
// //     Yup.number()
// //       .typeError(t('Required'))
// //       .moreThan(0, t('Required'))
// //       .required(t('Required')),
// //   otherwise: () =>
// //     Yup.mixed().notRequired()
// // })

//   unitPrice: Yup.number()
//             .transform((v, o) => (o === '' || o == null ? 0 : v))
//             .when('$methodTransfer', {
//               is: 2,
//               then: schema =>
//                 schema
//                   .typeError(() => t('Required'))
//                   .min(0, () => t('Required'))
//                   .required(() => t('Required')),
//               otherwise: schema => schema.notRequired()
//             })
//           // ✅ السعر فقط مطلوب لو methodTransfer=2
//           // unitPrice: Yup.number()
//           //   .transform((v, o) => (o === '' || o == null ? 0 : v))
//           //   .when('methodTransfer', {
//           //     is: 2,
//           //     then: schema =>
//           //       schema
//           //         .typeError(() => t('Required'))
//           //         .min(0, () => t('Required'))
//           //         .required(() => t('Required')),
//           //     otherwise: schema => schema.notRequired()
//           //   })
//         })
//       )
//   });
// };

export const AddMoveTransactionsSchema = (t, opts) => {
  const requireUnitPriceWhenManual = (opts && opts.requireUnitPriceWhenManual) ?? true;

  return Yup.object().shape({
    // رأس المستند
    code: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),

    branchId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),

    branchTo: Yup.string().required(() => t('Required')),
    inventoryTo: Yup.string().required(() => t('Required')),

    subInventoryId: Yup.mixed().nullable(),
    subInventoryTo: Yup.mixed().nullable(),

    referenceType: Yup.string().nullable(),

    // ✅ طريقة التسعير: 1=سعر تلقائي من التكلفة, 2=سعر يدوي
    methodTransfer: Yup.number()
      .required(() => t('Required'))
      .oneOf([1, 2], () => t('Required')),

    // البنود
    materialTransactionsLineList: Yup.array()
      .required(() => t('Required'))
      .min(1, () => t('Required'))
      .of(
        Yup.object().shape({
          transactionItemId: Yup.string().required(() => t('Required')),
          transactionUom: Yup.string().required(() => t('Required')),

          transactionQuantityIn: Yup.number()
            .typeError(() => t('Required'))
            .moreThan(0, () => t('Required'))
            .required(() => t('Required')),

          // (يصير مطلوب بشرط بالـ test أدناه)
          unitPrice: Yup.number().nullable()
        })
      )
      // ✅ شرط الإلزام: إذا methodTransfer=2 لازم كل بند له unitPrice
      .test(
        'unitPrice-required-when-manual',
        () => t('Required'),
        function (lines) {
          const methodTransfer = Number((this.parent && this.parent.methodTransfer) ?? 0);

          // ✅ لو الـ flag مقفول أو methodTransfer≠2 → لا نطلب unitPrice
          if (!requireUnitPriceWhenManual || methodTransfer !== 2) return true;

          const list = Array.isArray(lines) ? lines : [];
          const badIndex = list.findIndex(l => !(Number(l && l.unitPrice) > 0)); // لو تبغى يسمح بـ 0: استخدم >= 0

          if (badIndex === -1) return true;

          return this.createError({
            path: `materialTransactionsLineList[${badIndex}].unitPrice`,
            message: t('Required')
          });
        }
      )
  });
};

export const MasterItemsSchema = t => {
  return Yup.object().shape({
    itemCode: Yup.string().required(() => t('Required')),
    barcode: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    // displayName: Yup.string().required(() => t('Required')),
    // displayName2: Yup.string().required(() => t('Required')),
    categoryId: Yup.string()
      .trim()
      .required(() => t('Required')),
    itemType: Yup.string()
      .trim()
      .required(() => t('Required')),
    // salesPrice: Yup.string().required(() => t('Required')),
    // purchasePrice: Yup.string().required(() => t('Required')),
    unitOfMeasure: Yup.string()
      .trim()
      .required(() => t('Required')),

    expenseDistribute: Yup.string()
      .nullable(false)
      .when('itemType', {
        is: 'ExpenseItem',
        then: () => Yup.string().required(() => t('Required'))
      }),

    demandTimeUp: Yup.number()
      .typeError(() => t('Must be a number')) // إذا لم يكن رقماً
      .min(0, () => t('Must be zero or greater')) // يقبل 0 فما فوق
      .required(() => t('Required')), // الحقل مطلوب
    demandTimeDown: Yup.number()
      .typeError(() => t('Must be a number')) // إذا لم يكن رقماً
      .min(0, () => t('Must be zero or greater')) // يقبل 0 فما فوق
      .required(() => t('Required')),

    salesPrice: Yup.number()
      .typeError(() => t('Must be a number')) // إذا لم يكن رقماً
      .min(0, () => t('Must be zero or greater')) // يقبل 0 فما فوق
      .required(() => t('Required')),
    purchasePrice: Yup.number()
      .typeError(() => t('Must be a number')) // إذا لم يكن رقماً
      .min(0, () => t('Must be zero or greater')) // يقبل 0 فما فوق
      .required(() => t('Required')),
    discountRate: Yup.number()
      .typeError(() => t('Must be a number'))
      .min(0, () => t('Must be at least 0'))
      .max(100, () => t('Must be at most 100'))
    // .required(() => t('Required')),

    // image: "",

    // description: "",
  });
};

export const MasterItemsSchema2 = t => {
  // ✅ ساعدنا نحول "" إلى null عشان الحقول المخفية/الاختيارية ما تطلع أخطاء typeError
  const num = () =>
    Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) return null;
        return value;
      })
      .nullable()
      .typeError(() => t('Must be a number'));

  // ✅ قوائم حسب منطق Neatix (تقدر تعدلها بسهولة)
  const NEEDS_STOCK = ['InventoryItem', 'AssemblyItem']; // مخزون + حدود طلب
  const CAN_SELL = ['InventoryItem', 'AssemblyItem', 'ServiceItem']; // سعر بيع/خصم
  const NEEDS_PURCHASE_PRICE = ['InventoryItem', 'AssemblyItem', 'AssetItem']; // سعر شراء مهم
  const EXPENSE = 'ExpenseItem';

  return Yup.object().shape({
    itemCode: Yup.string()
      .trim()
      .required(() => t('Required')),
    barcode: Yup.string()
      .trim()
      .required(() => t('Required')),
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),

    categoryId: Yup.string()
      .trim()
      .required(() => t('Required')),

    itemType: Yup.string()
      .trim()
      .required(() => t('Required')),

    unitOfMeasure: Yup.string()
      .trim()
      .required(() => t('Required')),

    // ✅ أنت معلمها required في الـ UI
    taxCategory: Yup.string()
      .trim()
      .required(() => t('Required')),

    // ✅ مصروف فقط
    expenseDistribute: Yup.string()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .when('itemType', {
        is: v => v === EXPENSE,
        then: s => s.required(() => t('Required')),
        otherwise: s => s.notRequired()
      }),

    // ✅ حدود الطلب: فقط للمخزني + التجميعي (لأن لهم مخزون مستقل)
    demandTimeUp: num()
      .min(0, () => t('Must be zero or greater'))
      .when('itemType', {
        is: v => NEEDS_STOCK.includes(v),
        then: s => s.required(() => t('Required')),
        otherwise: s => s.notRequired()
      }),

    demandTimeDown: num()
      .min(0, () => t('Must be zero or greater'))
      .when('itemType', {
        is: v => NEEDS_STOCK.includes(v),
        then: s => s.required(() => t('Required')),
        otherwise: s => s.notRequired()
      }),

    // ✅ سعر البيع: للمخزني + التجميعي + الخدمي فقط
    salesPrice: num()
      .min(0, () => t('Must be zero or greater'))
      .when('itemType', {
        is: v => CAN_SELL.includes(v),
        then: s => s.required(() => t('Required')),
        otherwise: s => s.notRequired()
      }),

    // ✅ سعر الشراء: مهم للمخزني + التجميعي + الأصل
    // للخدمي قد يكون اختياري (حسب سياستكم)
    purchasePrice: num()
      .min(0, () => t('Must be zero or greater'))
      .when('itemType', {
        is: v => NEEDS_PURCHASE_PRICE.includes(v),
        then: s => s.required(() => t('Required')),
        otherwise: s => s.notRequired()
      }),

    // ✅ الخصم: منطقي فقط للأصناف التي تُباع (وهو اختياري)
    discountRate: num()
      .min(0, () => t('Must be at least 0'))
      .max(100, () => t('Must be at most 100'))
      .when('itemType', {
        is: v => CAN_SELL.includes(v),
        then: s => s.notRequired(),
        otherwise: s => s.notRequired()
      })
  });
};

export const ItemConversionSchema = t => {
  return Yup.object().shape({
    uom: Yup.string()
      .trim()
      .required(() => t('Required')),
    barcode: Yup.string()
      .trim()
      .required(() => t('Required')),
    conversionValue: Yup.number()
      .typeError(() => t('Must be a number'))
      .positive(() => t('Must be positive'))
      .required(() => t('Required'))
  });
};
export const LotItemSchema = t => {
  return Yup.object().shape({
    expirationDate: Yup.date().required(() => t('Required')),
    lotNumber: Yup.string()
      .trim()
      .required(() => t('Required'))
    // unitOfMeasure: Yup.string()
    //   .trim()
    //   .required(() => t('Required'))
  });
};

export const AttributeToItemSchema = t => {
  return Yup.object().shape({
    itemId: Yup.string()
      .trim()
      .required(() => t('Required')),
    uom: Yup.string()
      .trim()
      .required(() => t('Required')),
    attributeId: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const BrandSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required'))
  });
};

export const AddAttributeSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    attType: Yup.string().required(() => t('Required')),

    attributeValuesList: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .trim()
          .required(() => t('Required')),
        name2: Yup.string()
          .trim()
          .required(() => t('Required')),
        extraPrice: Yup.number().min(0, 'Quantity must be at least 0').required(),
        color: Yup.string()
          .trim()
          .required(() => t('Required'))
      })
    )
  });
};

export const TransactionTypeReasonsSchema = t => {
  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(() => t('Required')),
    name2: Yup.string()
      .trim()
      .required(() => t('Required')),
    description: Yup.string()
      .trim()
      .required(() => t('Required')),
    // description2: Yup.string()
    //   .trim()
    //   .required(() => t('Required')),
    accountId: Yup.string()
      .trim()
      .required(() => t('Required'))
    // glLedgerId: Yup.string()
    //   .trim()
    //   .required(() => t('Required'))
  });
};

//#region _______ Sales
export const AddPriceListSchema = t => {
  return Yup.object().shape({
    name: Yup.string().required(() => t('Required')),
    name2: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    startDateActive: Yup.date().required(() => t('Required'))
    // endDateActive: Yup.date().required(() => t('Required'))

    // description: '',
    // typeCode: '',
  });
};

export const AddQuoteInvoiceSchema = t => {
  return Yup.object().shape({
    // no: Yup.number().required(() => t('Required')),
    // code: Yup.string().required(() => t('Required')),
    // name: Yup.string().required(() => t('Required')),
    // name2: Yup.string().required(() => t('Required')),
    // transTypeId: Yup.string().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    peopleId: Yup.string().required(() => t('Required')),
    recipientname: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    expirationDate: Yup.date().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    // deliveryDate: Yup.date().required(() => t('Required')),
    // dueDate: Yup.date().required(() => t('Required')),
    // paymentTermsId: Yup.string().required(() => t('Required')),
    // personId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),
    // description: Yup.string(),
    // discountRate: Yup.number().min(0).max(100),
    // discountAmount: Yup.number().min(0),
    // vat: Yup.number().min(0),
    // netSale: Yup.number().min(0),
    // contractId: Yup.string(),
    // ameStatus: Yup.string(),
    // paymentTerms: Yup.string(),
    // deliveryTerm: Yup.string(),
    // waybill: Yup.string(),
    // phone: Yup.string(),
    // currencyConversionRate: Yup.number().min(0),
    // batchId: Yup.string(),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        description: Yup.string().nullable(),
        discountAmount: Yup.number().nullable(),
        discountRate: Yup.number().nullable(),
        itemId: Yup.string().required('رقم الصنف مطلوب'),
        lineNumber: Yup.number().required('رقم السطر مطلوب'),
        price: Yup.number().required('السعر مطلوب').positive('يجب أن يكون السعر رقم إيجابي'),
        qty: Yup.number().required('الكمية مطلوبة').positive('يجب أن تكون الكمية رقم إيجابي'),
        total: Yup.number().nullable(),
        uom: Yup.string().required('الوحدة مطلوبة'),
        vatAmount: Yup.number().nullable(),
        vatRate: Yup.number().nullable()
      })
    )
  });
};

export const SellOrderSchema = t => {
  return Yup.object().shape({
    // no: Yup.number().required(() => t('Required')),
    // code: Yup.string().required(() => t('Required')),
    // name: Yup.string().required(() => t('Required')),
    // name2: Yup.string().required(() => t('Required')),
    // transTypeId: Yup.string().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    peopleId: Yup.string().required(() => t('Required')),
    paymentMethodId: Yup.string().required(() => t('Required')),
    recipientname: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    // expirationDate: Yup.date().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    deliveryDate: Yup.date().required(() => t('Required')),
    dueDate: Yup.date().required(() => t('Required')),
    paymentTermsId: Yup.string().required(() => t('Required')),
    // personId:  Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),
    // description: Yup.string(),
    // discountRate: Yup.number().min(0).max(100),
    // discountAmount: Yup.number().min(0),
    // vat: Yup.number().min(0),
    // netSale: Yup.number().min(0),
    // contractId: Yup.string(),
    // ameStatus: Yup.string(),
    // paymentTerms: Yup.string(),
    // deliveryTerm: Yup.string(),
    // waybill: Yup.string(),
    // phone: Yup.string(),
    // currencyConversionRate: Yup.number().min(0),
    // batchId: Yup.string(),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        description: Yup.string().nullable(),
        discountAmount: Yup.number().nullable(),
        discountRate: Yup.number().nullable(),
        itemId: Yup.string().required('رقم الصنف مطلوب'),
        lineNumber: Yup.number().required('رقم السطر مطلوب'),
        price: Yup.number().required('السعر مطلوب').positive('يجب أن يكون السعر رقم إيجابي'),
        qty: Yup.number().required('الكمية مطلوبة').positive('يجب أن تكون الكمية رقم إيجابي'),
        total: Yup.number().nullable(),
        uom: Yup.string().required('الوحدة مطلوبة'),
        vatAmount: Yup.number().nullable(),
        vatRate: Yup.number().nullable()
      })
    )
  });
};

export const AddInvoiceSalesSchema = t => {
  return Yup.object().shape({
    // no: Yup.number().required(() => t('Required')),
    // code: Yup.string().required(() => t('Required')),
    // name: Yup.string().required(() => t('Required')),
    // name2: Yup.string().required(() => t('Required')),
    // transTypeId: Yup.string().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    peopleId: Yup.string().required(() => t('Required')),
    recipientname: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    deliveryDate: Yup.date().required(() => t('Required')),
    dueDate: Yup.date().required(() => t('Required')),
    paymentTermsId: Yup.string().required(() => t('Required')),
    personId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required'))
    // description: Yup.string(),
    // discountRate: Yup.number().min(0).max(100),
    // discountAmount: Yup.number().min(0),
    // vat: Yup.number().min(0),
    // netSale: Yup.number().min(0),
    // contractId: Yup.string(),
    // ameStatus: Yup.string(),
    // paymentTerms: Yup.string(),
    // deliveryTerm: Yup.string(),
    // waybill: Yup.string(),
    // phone: Yup.string(),
    // currencyCode: Yup.string(),
    // currencyConversionRate: Yup.number().min(0),
    // batchId: Yup.string(),
  });
};
export const AddPosSchema = (t, existingCodes) => {
  return Yup.object().shape({
    organizationId: Yup.string().required(() => t('Required')),
    peopleId: Yup.string().required(() => t('Required')),
    // posType: Yup.string().required(() => t('Required')),
    name: Yup.string().required(() => t('Required')),
    name2: Yup.string().required(() => t('Required')),
    // printTemplateId: Yup.string().required(() => t('Required')),
    inventoryId: Yup.string().required(() => t('Required')),

    code: Yup.string()
      .trim()
      .matches(/^[A-Za-z0-9_]+$/, t('OnlyEnglishLettersAndSomeSymbolsAreAllowed'))
      .required(() => t('Required'))
      .test('is-unique', t('Code Already Exists'), value => {
        if (!value) return true; // إذا كانت القيمة فارغة، لا داعي للتحقق
        const lowerCaseValue = value?.toLowerCase().trim(); // تحويل القيمة المدخلة إلى أحرف صغيرة
        const lowerCaseExistingNames = existingCodes?.map(name => name?.toLowerCase()); // تحويل الأسماء الموجودة إلى أحرف صغيرة
        return !lowerCaseExistingNames?.includes(lowerCaseValue); // التحقق من عدم التكرار
      })
  });
};

export const AddPosCasherSchema = t => {
  return Yup.object().shape({
    personId: Yup.string().required(() => t('Required')),
    startDate: Yup.string().required(() => t('Required'))
  });
};

// export const DiscountVouchersSchema = t => {
//   return Yup.object().shape({
//     name: Yup.string().required(() => t('Required')),
//     name2: Yup.string().required(() => t('Required')),
//     validationDateFrom: Yup.date().required(() => t('Required')),
//     voucherTypeId: Yup.string().required(() => t('Required')),
//     conditionalRulesType: Yup.string().required(() => t('Required')),

//     pricelIstId: Yup.string().when('conditionalRulesType', {
//       is: 'priceList',
//       then: () => Yup.string().required(() => t('Required'))
//     }),

//     maxPerCustomer: Yup.number().when('conditionalRulesType', {
//       is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(0, t('MustBeZeroOrMore'))
//     }),

//     conditionalRulesQty: Yup.number().when('conditionalRulesType', {
//       is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(1, t('MustBeOneOrMore'))
//     }),

//     conditionalRulesAmount: Yup.number().when('conditionalRulesType', {
//       is: val => ['amount'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(1, t('MustBeOneOrMore'))
//     }),

//     // discountVouchersItemsList: Yup.array().when(['conditionalRulesType', 'itemFilterType'], {
//     //   is: (conditionalRulesType, itemFilterType) =>
//     //     ['qtyOne', 'qtySum', 'qtyAll'].includes(conditionalRulesType) && itemFilterType === 'ITEM',

//     //   then: () => Yup.array().of(Yup.object().shape({})).min(1, 'حدد الأصناف')
//     // }),

//     // discountVouchersCategoriesList: Yup.array().when(['conditionalRulesType', 'itemFilterType'], {
//     //   is: (conditionalRulesType, itemFilterType) =>
//     //     ['qtyOne', 'qtySum', 'qtyAll'].includes(conditionalRulesType) && itemFilterType === 'CAT',

//     //   then: () => Yup.array().of(Yup.object().shape({})).min(1, 'حدد الأصناف')
//     // }),

//     discountVouchersRewards: Yup.object().when('conditionalRulesType', {
//       is: 'priceList',
//       then: () => Yup.object().notRequired(),
//       otherwise: () =>
//         Yup.object().shape({
//           rewardsType: Yup.string().required(t('Required')),

//           discountValue: Yup.number().when('rewardsType', {
//             is: val => ['DISCOUNTP', 'DISCOUNTA', 'FreeAdditionalItems', 'Award_Points'].includes(val),
//             then: () => Yup.number().min(0.01, t('Must be greater than 0')).required(t('Required')),
//             otherwise: () => Yup.number().notRequired()
//           }),
//           discountVouchersRewardsItemsList: Yup.array().when('rewardsType', {
//             is: 'FREE_ITEM',
//             then: () =>
//               Yup.array()
//                 .of(
//                   Yup.object().shape({
//                     itemId: Yup.string().required(),
//                     itemQty: Yup.number().min(1).required()
//                   })
//                 )
//                 .min(1, t('At least one free item required')),
//             otherwise: () => Yup.array().notRequired()
//           })
//         })
//     })

//     // discountVouchersRewards: Yup.object().shape({
//     //   rewardsType: Yup.string().required(t('Required')),

//     //   discountValue: Yup.number().when('rewardsType', {
//     //     is: val => ['DISCOUNTP', 'DISCOUNTA', 'FreeAdditionalItems', 'Award_Points'].includes(val),
//     //     then: ()=> Yup.number().min(0.01, t('Must be greater than 0')).required(t('Required')),
//     //     otherwise:()=> Yup.number().notRequired()
//     //   }),

//     //   discountVouchersRewardsItemsList: Yup.array().when('rewardsType', {
//     //     is: 'FREE_ITEM',
//     //     then: ()=> Yup.array()
//     //       .of(
//     //         Yup.object().shape({
//     //           itemId: Yup.string().required(),
//     //           itemQty: Yup.number().min(1).required()
//     //         })
//     //       )
//     //       .min(1, t('At least one free item required')),
//     //     otherwise:()=> Yup.array().notRequired()
//     //   })
//     // })
//   });
// };

// export const DiscountVouchersSchema = t => {
//   return Yup.object().shape({
//     name: Yup.string().required(() => t('Required')),
//     name2: Yup.string().required(() => t('Required')),
//     validationDateFrom: Yup.date().required(() => t('Required')),
//     voucherTypeId: Yup.string().required(() => t('Required')),
//     conditionalRulesType: Yup.string().required(() => t('Required')),

//     pricelIstId: Yup.string().when('conditionalRulesType', {
//       is: 'priceList',
//       then: () => Yup.string().required(() => t('Required')),
//       otherwise: () => Yup.string().notRequired()
//     }),

//     // ✅ الحقول العامة (تعمل فقط مع qtyOne/qtySum/qtyAll)
//     maxPerCustomer: Yup.number().when('conditionalRulesType', {
//       is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(0, t('MustBeZeroOrMore')),
//       otherwise: () => Yup.number().notRequired()
//     }),

//     conditionalRulesQty: Yup.number().when('conditionalRulesType', {
//       is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(1, t('MustBeOneOrMore')),
//       otherwise: () => Yup.number().notRequired()
//     }),

//     conditionalRulesAmount: Yup.number().when('conditionalRulesType', {
//       is: val => ['amount'].includes(val),
//       then: () =>
//         Yup.number()
//           .required(() => t('Required'))
//           .min(1, t('MustBeOneOrMore')),
//       otherwise: () => Yup.number().notRequired()
//     }),

//     // ✅ جدول الأصناف مطلوب فقط في qtyListItem
//     discountVouchersItemsList: Yup.array().when('conditionalRulesType', {
//       is: 'qtyListItem',
//       then: () =>
//         Yup.array()
//           .of(
//             Yup.object().shape({
//               itemId: Yup.string().required(() => t('Required')),
//               uom: Yup.string().required(() => t('Required')),

//               price: Yup.number()
//                 .typeError(t('MustBeNumber'))
//                 .min(0, t('MustBeZeroOrMore'))
//                 .required(() => t('Required')),

//               conditionQty: Yup.number()
//                 .typeError(t('MustBeNumber'))
//                 .min(1, t('MustBeOneOrMore'))
//                 .required(() => t('Required')),

//               maxPerCustomer: Yup.number()
//                 .typeError(t('MustBeNumber'))
//                 .min(0, t('MustBeZeroOrMore'))
//                 .required(() => t('Required')),

//               enabledFlag: Yup.boolean().notRequired()
//             })
//           )
//           .min(1, t('At least one item required')),
//       otherwise: () => Yup.array().notRequired()
//     }),

//     // ✅ Rewards: غير مطلوبة في priceList + qtyListItem
//     discountVouchersRewards: Yup.object().when('conditionalRulesType', {
//       is: val => ['priceList', 'qtyListItem'].includes(val),
//       then: () => Yup.object().notRequired(),
//       otherwise: () =>
//         Yup.object().shape({
//           rewardsType: Yup.string().required(() => t('Required')),

//           discountValue: Yup.number().when('rewardsType', {
//             is: val => ['DISCOUNTP', 'DISCOUNTA', 'FreeAdditionalItems', 'Award_Points'].includes(val),
//             then: () =>
//               Yup.number()
//                 .typeError(t('MustBeNumber'))
//                 .min(0.01, t('Must be greater than 0'))
//                 .required(() => t('Required')),
//             otherwise: () => Yup.number().notRequired()
//           }),

//           discountVouchersRewardsItemsList: Yup.array().when('rewardsType', {
//             is: 'FREE_ITEM',
//             then: () =>
//               Yup.array()
//                 .of(
//                   Yup.object().shape({
//                     itemId: Yup.string().required(() => t('Required')),
//                     itemQty: Yup.number()
//                       .typeError(t('MustBeNumber'))
//                       .min(1, t('MustBeOneOrMore'))
//                       .required(() => t('Required'))
//                   })
//                 )
//                 .min(1, t('At least one free item required')),
//             otherwise: () => Yup.array().notRequired()
//           })
//         })
//     })
//   });
// };

export const DiscountVouchersSchema = (t, mode) => {
  // const mode = options?.mode ?? 'edit';
  const isAdd = mode === 'add';

  return Yup.object().shape({
    name: Yup.string().required(() => t('Required')),
    name2: Yup.string().required(() => t('Required')),
    validationDateFrom: Yup.date().required(() => t('Required')),
    voucherTypeId: Yup.string().required(() => t('Required')),
    conditionalRulesType: Yup.string().required(() => t('Required')),

    // ✅ جديد
    priority: Yup.number().typeError(t('MustBeNumber')).min(0, t('MustBeZeroOrMore')).notRequired(),

    pricelIstId: Yup.string().when('conditionalRulesType', {
      is: 'priceList',
      then: () => Yup.string().required(() => t('Required')),
      otherwise: () => Yup.string().notRequired()
    }),

    // ✅ الحقول العامة (تعمل فقط مع qtyOne/qtySum/qtyAll)
    // ملاحظة: تركناها كما هي (رأس العرض)، إذا تبغاها تُدخل لاحقاً في التعديل قلّي وأرخّيها في add
    maxPerCustomer: Yup.number().when('conditionalRulesType', {
      is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
      then: () =>
        Yup.number()
          .required(() => t('Required'))
          .min(0, t('MustBeZeroOrMore')),
      otherwise: () => Yup.number().notRequired()
    }),

    conditionalRulesQty: Yup.number().when('conditionalRulesType', {
      is: val => ['qtyOne', 'qtySum', 'qtyAll'].includes(val),
      then: () =>
        Yup.number()
          .required(() => t('Required'))
          .min(1, t('MustBeOneOrMore')),
      otherwise: () => Yup.number().notRequired()
    }),

    conditionalRulesAmount: Yup.number().when('conditionalRulesType', {
      is: val => ['amount'].includes(val),
      then: () =>
        Yup.number()
          .required(() => t('Required'))
          .min(1, t('MustBeOneOrMore')),
      otherwise: () => Yup.number().notRequired()
    }),

    // ✅ جدول الأصناف:
    // - في ADD: لا مطلوب لأي نوع (حفظ بدون تفاصيل)
    // - في EDIT: يبقى كما هو (qtyListItem يطلب أصناف)
    discountVouchersItemsList: isAdd
      ? Yup.array().notRequired()
      : Yup.array().when('conditionalRulesType', {
          is: 'qtyListItem',
          then: () =>
            Yup.array()
              .of(
                Yup.object().shape({
                  itemId: Yup.string().required(() => t('Required')),
                  uom: Yup.string().required(() => t('Required')),

                  price: Yup.number()
                    .typeError(t('MustBeNumber'))
                    .min(0, t('MustBeZeroOrMore'))
                    .required(() => t('Required')),

                  conditionQty: Yup.number()
                    .typeError(t('MustBeNumber'))
                    .min(1, t('MustBeOneOrMore'))
                    .required(() => t('Required')),

                  maxPerCustomer: Yup.number()
                    .typeError(t('MustBeNumber'))
                    .min(0, t('MustBeZeroOrMore'))
                    .required(() => t('Required')),

                  enabledFlag: Yup.boolean().notRequired()
                })
              )
              .min(1, t('At least one item required')),
          otherwise: () => Yup.array().notRequired()
        }),

    // ✅ Rewards:
    // - في ADD: غير مطلوبة لكل الأنواع (لأنك ستضيفها بالتعديل)
    // - في EDIT: يبقى المنطق الحالي (غير مطلوبة في priceList + qtyListItem)
    discountVouchersRewards: isAdd
      ? Yup.mixed().nullable().notRequired()
      : Yup.object().when('conditionalRulesType', {
          is: val => ['priceList', 'qtyListItem'].includes(val),
          then: () => Yup.object().notRequired(),
          otherwise: () =>
            Yup.object().shape({
              rewardsType: Yup.string().required(() => t('Required')),

              discountValue: Yup.number().when('rewardsType', {
                is: val => ['DISCOUNTP', 'DISCOUNTA', 'FreeAdditionalItems', 'Award_Points'].includes(val),
                then: () =>
                  Yup.number()
                    .typeError(t('MustBeNumber'))
                    .min(0.01, t('Must be greater than 0'))
                    .required(() => t('Required')),
                otherwise: () => Yup.number().notRequired()
              }),

              discountVouchersRewardsItemsList: Yup.array().when('rewardsType', {
                is: 'FREE_ITEM',
                then: () =>
                  Yup.array()
                    .of(
                      Yup.object().shape({
                        itemId: Yup.string().required(() => t('Required')),
                        itemQty: Yup.number()
                          .typeError(t('MustBeNumber'))
                          .min(1, t('MustBeOneOrMore'))
                          .required(() => t('Required'))
                      })
                    )
                    .min(1, t('At least one free item required')),
                otherwise: () => Yup.array().notRequired()
              })
            })
        })
  });
};

export const AddSaleReturnsSchema = t => {
  return Yup.object().shape({
    // no: Yup.number().required(() => t('Required')),

    transactionDate: Yup.date().required(() => t('Required')),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        // qty: Yup.number().required('الكمية مطلوبة').positive('يجب أن تكون الكمية رقم إيجابي'),
        // ReturnQty: Yup.number()
        //   .required('الكمية المسترجعة مطلوبة')
        //   .positive('يجب أن تكون الكمية رقم إيجابي'),

        ReturnQty: Yup.string().when('selectedRow', {
          is: true,
          then: () => Yup.number().required('الكمية المسترجعة مطلوبة').positive('يجب أن تكون الكمية رقم إيجابي')
        })
      })
    )
  });
};

//#endregion

export const AddPurchaseRequestSchema = t => {
  return Yup.object().shape({
    // isAme: Yup.boolean(),

    categoryId: Yup.string().required(() => t('Required')),

    organizationId: Yup.string().required(() => t('Required')),

    // peopleId: Yup.string().required('People ID is required'),
    // recipientname: Yup.string().required('Recipient name is required'),
    // billToLocationId: Yup.string().nullable(),
    // shipToLocationId: Yup.string().required('Ship-to Location ID is required'),
    // referenceId: Yup.string().nullable(),
    transactionDate: Yup.date().required(() => t('Required')),
    deliveryDate: Yup.date().required(() => t('Required')),

    // expirationDate: Yup.date().nullable(),
    // dueDate: Yup.date().nullable(),
    // paymentTermsId: Yup.string().nullable(),
    // paymentMethodId: Yup.string().nullable(),
    // description: Yup.string().nullable(),
    // grossAmount: Yup.number().nullable(),
    // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').nullable(),
    // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').nullable(),
    // vat: Yup.number().min(0, 'VAT cannot be negative').nullable(),
    // netAmount: Yup.number().nullable(),
    // contractId: Yup.string().nullable(),
    // ameStatus: Yup.string().nullable(),
    // personId: Yup.string().nullable(),
    // paymentTerms: Yup.string().nullable(),
    // deliveryTerm: Yup.string().nullable(),
    // inventoryId: Yup.string().required(() => t('Required')),
    // waybill: Yup.string().nullable(),
    // phone: Yup.string().matches(/^\d+$/, 'Phone must be a number').nullable(),
    // currencyCode: Yup.string().nullable(),
    // currencyConversionRate: Yup.number().nullable(),
    // batchId: Yup.string().nullable(),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').required(),
        // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').required(),
        // itemId: Yup.string().required('Item ID is required'),
        // description: Yup.string().nullable(),
        // vatAmount: Yup.number().min(0, 'VAT amount cannot be negative').nullable(),
        // vatRate: Yup.number().min(0, 'VAT rate cannot be negative').nullable(),
        // lineNumber: Yup.number().min(1, 'Line number must be at least 1').required(),
        // price: Yup.number().min(0, 'Price cannot be negative').required(),
        // total: Yup.number().min(0, 'Total cannot be negative').required(),
        // uom: Yup.string().required(() => t('Required')),

        description: Yup.string().when('type', {
          is: 'Non_Inv',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string()
        }),

        // itemId: Yup.string().when('itemType', {
        //   is: 'UndefinedItem',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        itemId: Yup.string().when('itemType', {
          is: value => value !== 'UndefinedItem',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        }),
        // itemId: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        // uom: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        uom: Yup.string().required(() => t('Required')),

        qty: Yup.number().min(1, 'Quantity must be at least 1').required(),
        itemType: Yup.string().required(() => t('Required'))
      })
    )
  });
};

export const AddPurchaseOrderSchema = t => {
  return Yup.object().shape({
    // isAme: Yup.boolean(),

    // categoryId: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    deliveryDate: Yup.date().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),

    // inventoryId: Yup.string().required(() => t('Required')),

    inventoryId: Yup.string()
      .nullable()
      .when('isMulti', {
        is: false,
        then: () => Yup.string().required(() => t('Required'))
      }),

    peopleId: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    paymentMethodId: Yup.string().required(() => t('Required')),

    supplierInvoiceNum: Yup.string()
      .required(() => t('Required'))
      .trim()
      .max(50, () => t('MaxLength50')),
    // recipientname: Yup.string().required('Recipient name is required'),
    // billToLocationId: Yup.string().nullable(),
    // shipToLocationId: Yup.string().required('Ship-to Location ID is required'),
    // referenceId: Yup.string().nullable(),
    // expirationDate: Yup.date().nullable(),
    // dueDate: Yup.date().nullable(),
    // paymentTermsId: Yup.string().nullable(),
    // description: Yup.string().nullable(),
    // grossAmount: Yup.number().nullable(),
    // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').nullable(),
    // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').nullable(),
    // vat: Yup.number().min(0, 'VAT cannot be negative').nullable(),
    // netAmount: Yup.number().nullable(),
    // contractId: Yup.string().nullable(),
    // ameStatus: Yup.string().nullable(),
    // personId: Yup.string().nullable(),
    // paymentTerms: Yup.string().nullable(),
    // deliveryTerm: Yup.string().nullable(),
    // waybill: Yup.string().nullable(),
    // phone: Yup.string().matches(/^\d+$/, 'Phone must be a number').nullable(),
    // currencyConversionRate: Yup.number().nullable(),
    // batchId: Yup.string().nullable(),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').required(),
        // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').required(),
        // itemId: Yup.string().required('Item ID is required'),
        // description: Yup.string().nullable(),
        // vatAmount: Yup.number().min(0, 'VAT amount cannot be negative').nullable(),
        // vatRate: Yup.number().min(0, 'VAT rate cannot be negative').nullable(),
        // lineNumber: Yup.number().min(1, 'Line number must be at least 1').required(),
        // total: Yup.number().min(0, 'Total cannot be negative').required(),
        // uom: Yup.string().required(() => t('Required')),

        itemType: Yup.string().required(() => t('Required')),
        itemId: Yup.string().required(() => t('Required')),
        uom: Yup.string().required(() => t('Required')),

        // itemId: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        price: Yup.number()
          .min(0.01, 'يجب ان يكون السعر 0.01 على الأقل')
          .required(() => t('Required')),

        // description: Yup.string().when('itemType', {
        //   is: '',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string()
        // }),

        // uom: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        qty: Yup.number().min(0.01, 'يجب أن تكون الكمية 1 على الأقل').required(),
        // .min(0.01, 'Price cannot be negative')

        // inventoryId: Yup.string().when('isMulti', {
        //   is: false,
        //   then: () => Yup.string().required(() => t('Required'))
        // }),

        // inventoryId: Yup.string().when(['..isMulti'], {
        //   is: isMulti => isMulti === false,
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        inventoryId: Yup.string().when('isMulti', {
          is: false,
          then: () => Yup.string().required(),
          otherwise: () => Yup.string().nullable()
        })
      })
    )
  });
};
export const AddReturnPurchaseSchema = t => {
  return Yup.object().shape({
    // isAme: Yup.boolean(),

    // categoryId: Yup.string().required(() => t('Required')),
    transactionDate: Yup.date().required(() => t('Required')),
    deliveryDate: Yup.date().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),

    // inventoryId: Yup.string().required(() => t('Required')),

    inventoryId: Yup.string()
      .nullable()
      .when('isMulti', {
        is: false,
        then: () => Yup.string().required(() => t('Required'))
      }),

    peopleId: Yup.string().required(() => t('Required')),
    currencyCode: Yup.string().required(() => t('Required')),
    paymentMethodId: Yup.string().required(() => t('Required')),

    // supplierInvoiceNum: Yup.string()
    //   .required(() => t('Required'))
    //   .trim()
    //   .max(50, () => t('MaxLength50')),
    // recipientname: Yup.string().required('Recipient name is required'),
    // billToLocationId: Yup.string().nullable(),
    // shipToLocationId: Yup.string().required('Ship-to Location ID is required'),
    // referenceId: Yup.string().nullable(),
    // expirationDate: Yup.date().nullable(),
    // dueDate: Yup.date().nullable(),
    // paymentTermsId: Yup.string().nullable(),
    // description: Yup.string().nullable(),
    // grossAmount: Yup.number().nullable(),
    // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').nullable(),
    // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').nullable(),
    // vat: Yup.number().min(0, 'VAT cannot be negative').nullable(),
    // netAmount: Yup.number().nullable(),
    // contractId: Yup.string().nullable(),
    // ameStatus: Yup.string().nullable(),
    // personId: Yup.string().nullable(),
    // paymentTerms: Yup.string().nullable(),
    // deliveryTerm: Yup.string().nullable(),
    // waybill: Yup.string().nullable(),
    // phone: Yup.string().matches(/^\d+$/, 'Phone must be a number').nullable(),
    // currencyConversionRate: Yup.number().nullable(),
    // batchId: Yup.string().nullable(),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        // discountAmount: Yup.number().min(0, 'Discount amount cannot be negative').required(),
        // discountRate: Yup.number().min(0, 'Discount rate cannot be negative').required(),
        // itemId: Yup.string().required('Item ID is required'),
        // description: Yup.string().nullable(),
        // vatAmount: Yup.number().min(0, 'VAT amount cannot be negative').nullable(),
        // vatRate: Yup.number().min(0, 'VAT rate cannot be negative').nullable(),
        // lineNumber: Yup.number().min(1, 'Line number must be at least 1').required(),
        // total: Yup.number().min(0, 'Total cannot be negative').required(),
        // uom: Yup.string().required(() => t('Required')),

        itemType: Yup.string().required(() => t('Required')),
        itemId: Yup.string().required(() => t('Required')),
        uom: Yup.string().required(() => t('Required')),

        // itemId: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        price: Yup.number()
          .min(0.01, 'يجب ان يكون السعر 0.01 على الأقل')
          .required(() => t('Required')),

        // description: Yup.string().when('itemType', {
        //   is: '',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string()
        // }),

        // uom: Yup.string().when('type', {
        //   is: 'Inv',
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        qty: Yup.number().min(0.01, 'يجب أن تكون الكمية 1 على الأقل').required(),
        // .min(0.01, 'Price cannot be negative')

        // inventoryId: Yup.string().when('isMulti', {
        //   is: false,
        //   then: () => Yup.string().required(() => t('Required'))
        // }),

        // inventoryId: Yup.string().when(['..isMulti'], {
        //   is: isMulti => isMulti === false,
        //   then: () => Yup.string().required(() => t('Required')),
        //   otherwise: () => Yup.string().nullable()
        // }),

        inventoryId: Yup.string().when('isMulti', {
          is: false,
          then: () => Yup.string().required(),
          otherwise: () => Yup.string().nullable()
        })
      })
    )
  });
};

//#region _______ FA
export const AddAssetsSchema = t => {
  return Yup.object().shape({
    name: Yup.string().required(() => t('Required')),
    name2: Yup.string().required(() => t('Required')),
    assetNumber: Yup.string().required(() => t('Required')),
    tagNumber: Yup.string().required(() => t('Required')),
    serialNumber: Yup.string().required(() => t('Required')),
    categoryId: Yup.string().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),

    ownedLeased: Yup.string().required(() => t('Required')),
    leasedId: Yup.string().required(() => t('Required')),
    newUsed: Yup.string().required(() => t('Required')),
    depreciationMethod: Yup.string().required(() => t('Required')),

    assetCostAccount: Yup.string().required(() => t('Required')),
    deprnExpenseAccount: Yup.string().required(() => t('Required')),
    deprnReserveAccount: Yup.string().required(() => t('Required')),
    glLedgerId: Yup.string().required(() => t('Required')),
    datePlacedInService: Yup.date().required(() => t('Required')),

    originalCost: Yup.number().required(() => t('Required')),
    adjustedCost: Yup.number().required(() => t('Required')),
    percentage: Yup.number().required(() => t('Required')),
    salvageValue: Yup.number().required(() => t('Required')),
    lifeInMonths: Yup.number().required(() => t('Required'))
  });
};

export const AddDepreciationSchema = t => {
  return Yup.object().shape({
    // isAme: Yup.boolean(),

    transactionDate: Yup.date().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    categoryId: Yup.string().required(() => t('Required')),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        // assetId: Yup.string().required(() => t('Required'))

        assetId: Yup.string().when('depreciationType', {
          is: 'specificAssets',
          then: () => Yup.string().required(() => t('Required')),
          otherwise: () => Yup.string().nullable()
        })
      })
    )
  });
};
export const AddRevaluationSchema = t => {
  return Yup.object().shape({
    transactionDate: Yup.date().required(() => t('Required')),
    organizationId: Yup.string().required(() => t('Required')),
    categoryId: Yup.string().required(() => t('Required')),

    transactionsLinesList: Yup.array().of(
      Yup.object().shape({
        assetId: Yup.string().required(() => t('Required')),
        currentCost: Yup.number()
          .min(1, 'currentCost cannot be negative')
          .required(() => t('Required')),
        newCost: Yup.number()
          .min(1, 'newCost cannot be negative')
          .required(() => t('Required')),

        amount: Yup.number()
          .min(1, 'amount cannot be negative')
          .required(() => t('Required'))

        // retirementType: Yup.string().required(() => t('Required')),
        // removalCost: Yup.number()
        //   .min(0, 'removalCost cannot be negative')
        //   .required(() => t('Required'))
      })
    )
  });
};

export const SettlementTypesSchema = t =>
  Yup.object({
    name: Yup.string()
      .transform(v => (v ?? '').trim())
      .required(t?.('Required') ?? 'الحقل مطلوب')
      .min(2, t?.('MinLength2') ?? 'الحد الأدنى حرفين')
      .max(200, t?.('MaxLength200') ?? 'الحد الأقصى 200 حرف'),

    name2: Yup.string()
      .transform(v => (v ?? '').trim())
      .required(t?.('Required') ?? 'الحقل مطلوب')
      .min(2, t?.('MinLength2') ?? 'الحد الأدنى حرفين')
      .max(200, t?.('MaxLength200') ?? 'الحد الأقصى 200 حرف'),

    // react-select يرجع null -> لازم نخليه nullable ثم نطلبه
    accountId: Yup.string()
      .nullable()
      .required(t?.('Required') ?? 'يجب اختيار الحساب'),

    allowedDiffMode: Yup.mixed()
      .oneOf([1, 2, 3], t?.('InvalidValue') ?? 'قيمة غير صحيحة')
      .required(t?.('Required') ?? 'الحقل مطلوب'),

    isActive: Yup.boolean().default(true)
  });

//#endregion
